<script setup>
import { __ } from 'JIX/gettext';

defineProps({
    dataset: {
        type: Object,
        required: true,
    },
});

</script>


<template>
    <div class="table-responsive">
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>{{ __('Navn') }}</th>
                    <th>{{ __('Antal') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="elem, index in dataset.data" :key="elem.name + index">
                    <td v-if="elem.link">
                        <a :href="elem.link">{{ elem.name }}</a>
                    </td>
                    <td v-else>
                        {{ elem.name }}
                    </td>
                    <td>{{ elem.y }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>